/**
 * Zamknięta lista błędów wyceny z odpowiedzi quote (backend: PricingErrorType).
 * Błędy przychodzą per uczestnik w `ParticipantQuoteDto.errors`; obecność
 * jakiegokolwiek błędu oznacza, że `paymentPlan` nie powstanie i `book`
 * zostanie odrzucone.
 */
export enum PricingErrorType {
  NO_BASE_PRICE_AVAILABLE_FOR_PARTICIPANT_WITH_AGE = 'NO_BASE_PRICE_AVAILABLE_FOR_PARTICIPANT_WITH_AGE',
  REQUIRED_OPTION_NOT_SELECTED = 'REQUIRED_OPTION_NOT_SELECTED',
  OPTION_VARIANT_NOT_FOUND = 'OPTION_VARIANT_NOT_FOUND',
  OPTION_PRICE_NOT_FOUND = 'OPTION_PRICE_NOT_FOUND',
  OPTION_PRICE_NOT_AVAILABLE_FOR_AGE = 'OPTION_PRICE_NOT_AVAILABLE_FOR_AGE',
  OPTION_MULTI_SELECT_NOT_ALLOWED = 'OPTION_MULTI_SELECT_NOT_ALLOWED',
  OPTION_ARCHIVED = 'OPTION_ARCHIVED',
  OPTION_VARIANT_ARCHIVED = 'OPTION_VARIANT_ARCHIVED',
  OPTION_PRICE_ARCHIVED = 'OPTION_PRICE_ARCHIVED',
  TOUR_FULL = 'TOUR_FULL',
  OPTION_FULL = 'OPTION_FULL',
  OPTION_VARIANT_FULL = 'OPTION_VARIANT_FULL',
  TRANSPORT_NOT_OFFERED = 'TRANSPORT_NOT_OFFERED',
  TRANSPORT_SELECTION_REQUIRED = 'TRANSPORT_SELECTION_REQUIRED',
  TRANSPORT_VARIANT_NOT_FOUND = 'TRANSPORT_VARIANT_NOT_FOUND',
  TRANSPORT_AGE_NOT_ELIGIBLE = 'TRANSPORT_AGE_NOT_ELIGIBLE',
  TRANSPORT_VARIANT_SOLD_OUT = 'TRANSPORT_VARIANT_SOLD_OUT',
}
